$shm_hitalama_app_overlay $mol_view
	hide_popover null
	show_popover* null
	sub /
		<= Overlayed_map_holder $mol_view
			sub <= overlayed_map_visible /
				<= Overlayed_map $shm_hitalama_map_overlayed
					entity <= overlayed_map_entity null
		<= Quick_access $shm_hitalama_profile_quick
		<= Notifications $shm_hitalama_notifications
		^ fullscreen_panel / <= Fullscreen_panel $mol_view
			sub /
				<= Fullscreen_close $mol_link_iconed
					sub /
						<= Fullscreen_close_icon $mol_icon_arrow_expand_all
					uri <= fullscreen_close_uri \
